export const frPinCodes = {
    'pincodes.name': 'Code pin',
    'pincodes.title': 'Code pin',
    'pincodes.navbar': 'Code pin',

    // LIST
    'pincodes.list.pageTitle': 'Code pin',
    'pincodes.list.actions.addPinCode': 'Créer un code pin',
    'pincodes.list.table.emptyLabel': "Il n'y a pas de code pin pour le moment",
    'pincodes.list.table.headers.startDate': 'Date de début',
    'pincodes.list.table.headers.endDate': 'Date limite',
    'pincodes.list.table.headers.code': 'Code',
    'pincodes.list.table.headers.state': 'État',
    'pincodes.list.dialog.title': "Suppression d'un code pin",
    'pincodes.list.dialog.content': 'Êtes-vous sûr de vouloir supprimer ce code pin ?',
    'pincodes.list.table.state.Upcoming': 'À venir',
    'pincodes.list.table.state.InProgress': 'En cours',
    'pincodes.list.table.state.Expired': 'Terminé',

    // CREATE
    'pincodes.create.pageTitle': 'Code pin',
    'pincodes.create.tabs.right.corner': 'Code pin',
    'pincodes.create.tabs.info': 'Paramétrer un code pin',
    'pincodes.create.tabs.endDate': 'Date de fin',
    'pincodes.create.tabs.startDate': 'Date de début',
    'pincodes.create.tabs.code': 'Choix des 4 chiffres du code PIN',

    // DETAILS
    'pincodes.details.pageTitle': 'Code pin',
    'pincodes.details.actions.previous': 'Code pin',

    'toast.apiErrors.PIN_CODE_INVALID_DATE': 'Dates incorrectes',
    'toast.apiErrors.PIN_CODE_INVALID_LENGTH': 'Code pin incorrect',
    'toast.apiErrors.PIN_CODE_DATE_OVERLAPPING':
        'Les dates ne peuvent pas se chevaucher avec un autre code pin',
};
